document.addEventListener('DOMContentLoaded', () => {
  const SESSION_KEY = 'bb_tray_state';
  const tray = document.querySelector('.bundle-tray');
  if (!tray) return;

  // Desktop tray injection for sticky layout
  const gridContainer = document.querySelector('.bundle-variant-grid__container');
  if (gridContainer && window.innerWidth >= 990) {
    gridContainer.style.display = 'flex';
    gridContainer.style.flexDirection = 'row';
    gridContainer.style.flexWrap = 'nowrap';
    gridContainer.style.alignItems = 'flex-start';
    gridContainer.style.gap = '24px';
    // Let page-width padding remain intact for centering
    
    // Create a new div to hold the grid items to allow flex child layout
    const gridContent = document.createElement('div');
    gridContent.style.flex = '1';
    gridContent.style.minWidth = '0';
    
    // Move rail and grid into gridContent
    const rail = gridContainer.querySelector('.bundle-filter-rail');
    const grid = gridContainer.querySelector('.bundle-variant-grid');
    if (rail) gridContent.appendChild(rail);
    if (grid) gridContent.appendChild(grid);
    
    gridContainer.appendChild(gridContent);
    gridContainer.appendChild(tray);
    
    // Update tray CSS for sticky behavior
    tray.style.position = 'sticky';
    tray.style.top = '100px';
    tray.style.height = 'calc(100vh - 120px)';
    tray.style.width = '360px';
    tray.style.flexShrink = '0';
    tray.style.borderRadius = '24px';
    tray.style.boxShadow = '0 10px 30px rgba(0,0,0,0.1)';
  }

  const unlockQty = parseInt(tray.dataset.unlockQuantity, 10) || 5;
  const distanceTextTemplate = tray.dataset.distanceText || '{remaining} more to unlock $10 each';
  const distanceTextUnlocked = tray.dataset.distanceTextUnlocked || '$10 each · free shipping';
  const bundlePrice = parseInt(tray.dataset.bundlePrice, 10) || 1000;
  const comparePrice = parseInt(tray.dataset.comparePrice, 10) || 1200;
  
  const sizePicker = document.querySelector('.bundle-size-picker');
  const sizeChips = document.querySelectorAll('.bundle-size-picker__chip');
  
  const savingsBlockData = document.querySelector('.bundle-tray__savings-block');
  const copyEmpty = (savingsBlockData?.dataset.copyEmpty || '').split('|');
  const copyProgress = (savingsBlockData?.dataset.copyProgress || '').split('|');
  const copyUnlocked = (savingsBlockData?.dataset.copyUnlocked || '').split('|');
  const copyOver = (savingsBlockData?.dataset.copyOver || '').split('|');

  let state = {
    globalSize: 'Medium',
    items: [] // { id, qty, size, shape, colour, price, variantsMap, image }
  };

  // Restore state
  const remember = sizePicker && sizePicker.dataset.remember === 'true';
  if (remember) {
    const saved = sessionStorage.getItem(SESSION_KEY);
    if (saved) {
      try {
        state = JSON.parse(saved);
      } catch (e) {}
    }
  }
  
  // Set initial global size visually
  if (sizeChips.length) {
    sizeChips.forEach(chip => chip.setAttribute('aria-checked', chip.dataset.size === state.globalSize ? 'true' : 'false'));
  }

  // Bind size picker
  sizeChips.forEach(chip => {
    chip.addEventListener('click', () => {
      const size = chip.dataset.size;
      sizeChips.forEach(c => c.setAttribute('aria-checked', 'false'));
      chip.setAttribute('aria-checked', 'true');
      state.globalSize = size;
      
      state.globalSize = size;
      
      // Removed retroactive size updates for existing items in the bundle. 
      // Size toggles will now only apply to new items added from the grid.
      
      saveState();
      renderTray();
    });
  });

  // Mobile tray toggle
  const trayHeader = tray.querySelector('.bundle-tray__header');
  if (trayHeader) {
    const updateTrayHeaderHeight = () => {
      tray.style.setProperty('--tray-header-height', `${trayHeader.offsetHeight}px`);
    };
    updateTrayHeaderHeight();
    window.addEventListener('resize', updateTrayHeaderHeight);

    trayHeader.addEventListener('click', () => {
      if (window.innerWidth < 990) {
        tray.classList.toggle('is-expanded');
      }
    });
  }

  // Bind Grid Tiles
  const tiles = document.querySelectorAll('.bb-tile');
  tiles.forEach(tile => {
    const btnPlus = tile.querySelector('.bb-tile__stepper-plus');
    const btnMinus = tile.querySelector('.bb-tile__stepper-minus');
    const imgUrl = tile.dataset.image || '';
    
    const addItem = (e) => {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      const variantsMap = JSON.parse(tile.dataset.variants);
      const shape = tile.dataset.shape;
      const colour = tile.dataset.colour;
      const size = state.globalSize;
      const id = variantsMap[size];
      
      let oldQty = state.items.reduce((acc, item) => acc + item.qty, 0);
      let existing = state.items.find(i => i.shape === shape && i.colour === colour && i.size === size);
      if (existing) {
        existing.qty += 1;
      } else {
        state.items.push({
          id, qty: 1, size, shape, colour, 
          variantsMap, image: imgUrl, swatchStyle: tile.dataset.swatchStyle || ''
        });
      }
      
      let newQty = oldQty + 1;
      if (oldQty < unlockQty && newQty >= unlockQty && window.innerWidth < 990) {
        tray.classList.add('is-expanded');
      }
      
      saveState();
      renderTray();
    };
    
    const removeItem = (e) => {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      const shape = tile.dataset.shape;
      const colour = tile.dataset.colour;
      const size = state.globalSize;
      
      let existing = state.items.find(i => i.shape === shape && i.colour === colour && i.size === size);
      if (existing) {
        existing.qty -= 1;
        if (existing.qty <= 0) {
          state.items = state.items.filter(i => i !== existing);
        }
      }
      saveState();
      renderTray();
    };

    tile.addEventListener('click', (e) => {
      if (e.target.closest('.bb-tile__control-active')) return;
      addItem(e);
    });
    
    if (btnPlus) btnPlus.addEventListener('click', addItem);
    if (btnMinus) btnMinus.addEventListener('click', removeItem);
  });
  
  // Color Rail
  const filterChips = document.querySelectorAll('.bundle-filter-chip');
  if (filterChips.length) {
    // Generate distinct colors
    const colorsMap = new Map();
    tiles.forEach(t => {
      const col = t.dataset.colour;
      if (!colorsMap.has(col)) {
        colorsMap.set(col, { count: 0, image: t.dataset.image || '', swatchStyle: t.dataset.swatchStyle || '' });
      }
      colorsMap.get(col).count++;
    });
    
    const railContainer = document.querySelector('.bundle-filter-rail__chips');
    colorsMap.forEach((data, col) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'bundle-filter-chip';
      btn.setAttribute('aria-pressed', 'false');
      btn.dataset.filter = col;
      
      const finalSwatch = data.swatchStyle ? `style="${data.swatchStyle}"` : `style="background-image: url(${data.image})"`;
      btn.innerHTML = `
        <div class="bundle-filter-chip__swatch" ${finalSwatch}></div>
        <span class="bundle-filter-chip__name">${col}</span>
        <span class="bundle-filter-chip__count">${data.count}</span>
      `;
      
      btn.addEventListener('click', () => {
        filterChips.forEach(c => c.setAttribute('aria-pressed', 'false'));
        document.querySelectorAll('.bundle-filter-chip').forEach(c => c.setAttribute('aria-pressed', 'false'));
        btn.setAttribute('aria-pressed', 'true');
        
        tiles.forEach(t => {
          t.style.display = t.dataset.colour === col ? '' : 'none';
        });
      });
      
      railContainer.appendChild(btn);
    });
    
    document.querySelector('.bundle-filter-chip--all').addEventListener('click', (e) => {
      document.querySelectorAll('.bundle-filter-chip').forEach(c => c.setAttribute('aria-pressed', 'false'));
      e.currentTarget.setAttribute('aria-pressed', 'true');
      tiles.forEach(t => t.style.display = '');
    });
  }

  // Filter Rail Scroll Shadows
  const chipsContainer = document.querySelector('.bundle-filter-rail__chips');
  if (chipsContainer) {
    const updateScrollShadows = () => {
      const { scrollLeft, scrollWidth, clientWidth } = chipsContainer;
      chipsContainer.parentElement.classList.toggle('has-scroll-left', scrollLeft > 0);
      chipsContainer.parentElement.classList.toggle('has-scroll-right', Math.ceil(scrollLeft + clientWidth) < scrollWidth);
    };
    chipsContainer.addEventListener('scroll', updateScrollShadows);
    window.addEventListener('resize', updateScrollShadows);
    // Initial check after a short delay to allow for rendering/layout
    setTimeout(updateScrollShadows, 100);
  }

  // Tray Logic
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(0);
  }

  function saveState() {
    if (remember) {
      sessionStorage.setItem(SESSION_KEY, JSON.stringify(state));
    }
  }

  function renderTray() {
    let totalQty = state.items.reduce((acc, item) => acc + item.qty, 0);
    const isUnlocked = totalQty >= unlockQty;
    
    // Update Tiles visually
    tiles.forEach(tile => {
      const shape = tile.dataset.shape;
      const colour = tile.dataset.colour;
      const itemQty = state.items
        .filter(i => i.shape === shape && i.colour === colour)
        .reduce((acc, item) => acc + item.qty, 0);
      
      if (itemQty > 0) {
        tile.setAttribute('aria-pressed', 'true');
        tile.dataset.qty = itemQty;
        tile.querySelector('.bb-tile__count-val').textContent = itemQty;
        tile.querySelector('.bb-tile__badge-count').textContent = itemQty;
      } else {
        tile.setAttribute('aria-pressed', 'false');
        tile.dataset.qty = 0;
      }
    });

    // Update Progress
    const meter = document.querySelector('.bundle-tray__progress-meter');
    const segments = meter.querySelectorAll('.bundle-tray__progress-segment');
    segments.forEach((seg, i) => {
      seg.classList.toggle('filled', i < totalQty);
    });
    
    const extraChip = document.querySelector('.bundle-tray__progress-chip');
    if (extraChip) {
      if (totalQty > unlockQty) {
        extraChip.style.display = '';
        extraChip.querySelector('.bundle-tray__extra-count').textContent = totalQty - unlockQty;
      } else {
        extraChip.style.display = 'none';
      }
    }

    // Header strings
    const checkIcon = document.querySelector('.bundle-tray__check-icon');
    const counterText = document.querySelector('.bundle-tray__counter-text');
    const distText = document.querySelector('.bundle-tray__distance');
    
    if (isUnlocked) {
      checkIcon.style.display = '';
      counterText.textContent = `${totalQty} pairs · unlocked`;
      distText.textContent = distanceTextUnlocked;
    } else {
      checkIcon.style.display = 'none';
      counterText.textContent = `${totalQty} of ${unlockQty} pairs`;
      distText.textContent = distanceTextTemplate.replace('{remaining}', unlockQty - totalQty);
    }

    // Savings Block
    const title = document.querySelector('.bundle-tray__savings-title');
    const sub = document.querySelector('.bundle-tray__savings-subtitle');
    const grossTotal = totalQty * comparePrice;
    const newTotal = isUnlocked ? (totalQty * bundlePrice) : (totalQty * comparePrice);
    const savings = grossTotal - newTotal;
    
    let copy;
    if (totalQty === 0) copy = copyEmpty;
    else if (!isUnlocked) copy = copyProgress;
    else if (totalQty === unlockQty) copy = copyUnlocked;
    else copy = copyOver;
    
    const processCopy = (str) => {
      if (!str) return '';
      return str.replace('{count}', totalQty)
                .replace('{remaining}', unlockQty - totalQty)
                .replace('{total}', formatMoney(newTotal))
                .replace('{gross_total}', formatMoney(grossTotal))
                .replace('{savings}', formatMoney(savings));
    };
    
    title.innerHTML = processCopy(copy[0]).replace(/~~(.*?)~~/g, '<span class="bundle-tray__savings-strike">$1</span>');
    if (copy.length >= 3) {
      document.querySelector('.bundle-tray__savings-prices').innerHTML = processCopy(copy[1]).replace(/~~(.*?)~~/g, '<span class="bundle-tray__savings-strike">$1</span>');
      sub.innerHTML = processCopy(copy[2]);
    } else {
      sub.innerHTML = processCopy(copy[1]);
      const pricesEl = document.querySelector('.bundle-tray__savings-prices');
      if (pricesEl) pricesEl.innerHTML = '';
    }

    // Render Lines
    const linesContainer = document.querySelector('.bundle-tray__lines');
    linesContainer.innerHTML = '';
    
    state.items.forEach((item, index) => {
      for(let i=0; i<item.qty; i++) {
        const line = document.createElement('div');
        line.className = 'bundle-tray__line';
        const linePrice = isUnlocked ? bundlePrice : comparePrice;
        
        line.innerHTML = `
          <div class="bundle-tray__line-image">
            <img src="${item.image}" alt="" />
          </div>
          <div class="bundle-tray__line-info">
            <span class="bundle-tray__line-title">${item.shape}</span>
            <span class="bundle-tray__line-color">${item.colour}</span>
            <div class="bundle-tray__line-sizes">
              <span class="bundle-tray__line-size ${item.size === 'Small' ? 'selected' : ''}" data-size="Small">S</span>
              <span class="bundle-tray__line-size ${item.size === 'Medium' ? 'selected' : ''}" data-size="Medium">M</span>
              <span class="bundle-tray__line-size ${item.size === 'Large' ? 'selected' : ''}" data-size="Large">L</span>
            </div>
          </div>
          <span class="bundle-tray__line-price">${formatMoney(linePrice)}</span>
          <button type="button" class="bundle-tray__line-remove" aria-label="Remove">&times;</button>
          <button type="button" class="bundle-tray__line-undo">Undo</button>
        `;
        
        // Size changing
        line.querySelectorAll('.bundle-tray__line-size').forEach(btn => {
          btn.addEventListener('click', () => {
            const newSize = btn.dataset.size;
            item.size = newSize;
            item.id = item.variantsMap[newSize];
            saveState();
            renderTray();
          });
        });

        // Removal
        const removeBtn = line.querySelector('.bundle-tray__line-remove');
        const undoBtn = line.querySelector('.bundle-tray__line-undo');
        let removeTimeout;
        
        removeBtn.addEventListener('click', () => {
          line.classList.add('removed');
          removeTimeout = setTimeout(() => {
            item.qty -= 1;
            if (item.qty <= 0) state.items = state.items.filter(x => x !== item);
            saveState();
            renderTray();
          }, 5000);
        });
        
        undoBtn.addEventListener('click', () => {
          clearTimeout(removeTimeout);
          line.classList.remove('removed');
        });
        
        linesContainer.appendChild(line);
      }
    });

    // Footer
    const totalRow = document.querySelector('.bundle-tray__total-row');
    const checkoutBtn = document.querySelector('.bundle-tray__checkout-btn');
    
    if (totalQty > 0) {
      totalRow.style.display = 'flex';
      const orig = document.querySelector('.bundle-tray__total-price-original');
      const finalp = document.querySelector('.bundle-tray__total-price-final');
      
      if (isUnlocked) {
        orig.style.display = 'block';
        orig.textContent = formatMoney(grossTotal);
      } else {
        orig.style.display = 'none';
      }
      finalp.textContent = formatMoney(newTotal);
      
      checkoutBtn.disabled = false;
      if (isUnlocked) {
        checkoutBtn.textContent = `Add ${totalQty} to cart · ${formatMoney(newTotal)}`;
      } else {
        checkoutBtn.textContent = `Add ${totalQty} to cart · ${formatMoney(newTotal)}`;
      }
    } else {
      totalRow.style.display = 'none';
      checkoutBtn.disabled = true;
      checkoutBtn.textContent = 'Pick your first pair';
    }
    
    // Live region announcement
    const live = document.querySelector('.bundle-tray__live-region');
    let ann = `${totalQty} of ${unlockQty} selected. ${formatMoney(newTotal)} total. `;
    if (!isUnlocked) ann += `${unlockQty - totalQty} more pair to unlock $10 a pair and free shipping.`;
    else ann += `Unlocked.`;
    live.textContent = ann;
  }
  
  // Checkout logic
  const checkoutBtn = document.querySelector('.bundle-tray__checkout-btn');
  checkoutBtn.addEventListener('click', () => {
    if (state.items.length === 0) return;
    
    checkoutBtn.disabled = true;
    checkoutBtn.textContent = 'Adding...';
    
    const items = [];
    state.items.forEach(item => {
      items.push({
        id: item.id,
        quantity: item.qty
      });
    });
    
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items })
    })
    .then(response => {
      if (!response.ok) throw new Error('Failed to add to cart');
      return response.json();
    })
    .then(() => {
      window.location.href = '/checkout';
    })
    .catch((error) => {
      console.error('Error:', error);
      checkoutBtn.disabled = false;
      checkoutBtn.textContent = 'Error. Try again';
    });
  });

  // Initial render
  renderTray();
});
